export default __webpack_public_path__ + "static/media/logo-for-dark-bg.482b2fd0.png";